import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  DataTable,
  Field,
  DateTimeField,
  ContractEONType,
  ContractTypeBadgeField,
  ResponsibleField,
} from '../../commons/DataTable';
import CurrencyField from '../../commons/DataTable/CurrencyField';

function ContractsTable({ data, total, offset, limit, onFilter, bottomRow }) {
  const [t] = useTranslation('IAF_INVOICES');

  return (
    <DataTable
      data={data}
      total={total}
      offset={offset}
      limit={limit}
      onFilter={onFilter}
      emptyText={t('COMMON:NO_DATA')}
      bottomRow={bottomRow}
    >
      <Field title="Nome cliente" source="condo_name" className="text-left" />
      <Field title="Partita IVA cliente" source="condo_vat_cf" sticky={true} />
      <Field
        title="partita iva responsabile"
        source="admin_profile.fiscalCode"
        sticky={true}
      />

      <ContractEONType
        title="Nome prodotto"
        source="product_name"
        sticky={true}
      />
      <Field title="POD/PDR" source="pod_pdr" sticky={true} />
      <ContractTypeBadgeField title="Voce" source="partnerEonType" />
      <Field
        title="Consumo da contratto"
        source="initial_contractual_consumption"
        hideForStorno
      />
      <ResponsibleField title="Responsabile" source="admin_profile.name" />
      <CurrencyField title="Profitto Extra" source="extraShare" />
      <CurrencyField title="Profitto Admin" source="adminShare" />
      <CurrencyField
        title="Profitto Responsabile di zona"
        source="commercialShare1"
        hideForStorno
      />
      <CurrencyField
        title="Profitto Commerciale 1"
        source="commercialShare2"
        hideForStorno
      />
      <CurrencyField
        title="Profitto Commerciale 2"
        source="commercialShare3"
        hideForStorno
      />

      <DateTimeField
        title="Data creazione"
        source="contract_signing_date"
        format="DD/MM/YYYY"
      />
      <DateTimeField
        title="Data attivazione"
        source="activation_start_date"
        format="DD/MM/YYYY"
      />
      <DateTimeField
        title="Data Scadenza"
        source="contract_end_date"
        format="DD/MM/YYYY"
        hideForStorno
      />
    </DataTable>
  );
}

export default ContractsTable;
